import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalVideoComponent } from '../components/modal-video/modal-video.component';
import { GenericMessageModalProperties } from '@utilities/components/generic-message-modal/generic-message-modal-properties.interface';
import { GenericMessageModalComponent } from '@utilities/components/generic-message-modal/generic-message-modal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { httpErrorResponseToText } from '@utilities/functions/http-error-response-to-text';
import { Router } from '@angular/router';
import { WishlistItemAddedModalComponent } from '../components/wishlist-item-added-modal/wishlist-item-added-modal.component';
import { Catalog } from '../../rewards/interfaces/search-catalog-response.interface';
import { CreateNewWishlistModalComponent } from '../components/create-new-wishlist-modal/create-new-wishlist-modal.component';
import { ModalOrdersByConfirmComponent } from '../../home/components/modal-orders-by-confirm/modal-orders-by-confirm.component';
import { GetOrdersByConfirmResponse } from '../../home/interfaces/get-orders-by-confirm.response';
import { httpTitleResponseToText } from '@utilities/functions/http-title-response-to-text';
import { ModalMyProgressComponent } from '../../core/components/modal-my-progress/modal-my-progress.component';

@Injectable({ providedIn: 'root' })
export class ModalService {
  private ngbModal = inject(NgbModal);
  private router = inject(Router);

  openModalVideo() {
    this.ngbModal.open(ModalVideoComponent, {
      centered: true,
    });
  }

  openGenericModal(properties: GenericMessageModalProperties) {
    const modal = this.ngbModal.open(GenericMessageModalComponent, {
      centered: true,
    });
    modal.componentInstance.properties.set(properties);
  }

  showErrorModal(err: HttpErrorResponse) {
    this.ngbModal
      .open(GenericMessageModalComponent, {
        centered: true,
      })
      .componentInstance.properties.set({
        title: httpTitleResponseToText(err),
        body: httpErrorResponseToText(err),
      } as GenericMessageModalProperties);
  }

  addArticleSuccess() {
    this.openGenericModal({
      title: '¡ARTÍCULO AGREGADO EXITOSAMENTE!',
      body: 'Continúa con tu compra',
      buttons: [
        {
          label: 'Ver carrito',
          styleClass: 'perfilbtn-pep',
          action: () => this.router.navigate(['/cart']),
        },
      ],
    });
  }

  saveArticleInWishList(article: Catalog) {
    const modalRef = this.ngbModal.open(WishlistItemAddedModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.article.set(article);
  }

  createNewWishList(article: Catalog) {
    const modalRef = this.ngbModal.open(CreateNewWishlistModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.article.set(article);
  }

  ordersByConfirm(ordersByConfirm: GetOrdersByConfirmResponse[]) {
    const modalRef = this.ngbModal.open(ModalOrdersByConfirmComponent, {
      centered: true,
    });
    modalRef.componentInstance.ordersByConfirm.set(ordersByConfirm);
  }

  openMyProgressModal() {
    this.ngbModal.open(ModalMyProgressComponent, {
      centered: true,
      size: 'xl',
      scrollable: true,
    });
  }
}
